import { CartResponse, SessionStorageKeys } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { dispatchResetCartEvent } from 'app/bundle/store/handlers/cart.handler';
import { ResponseError } from 'app/shared/models/response-error.error';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { abandonCart, removeItemFromCart, retrieveCart } from 'app/shared/services/cart/cart.service';
import { getAddressFromCart, isSameAddress } from 'app/shared/utilities/address.util';
import { mapper } from 'app/shared/mappers/mapper';

export const onGuidedFlowLoad = async (): Promise<void> => {
  const cart = await retrieveCart();
  if (cart) {
    storeCartResponse(cart);
  }
};

export const onRemoveCartItem = async (sku: string): Promise<void> => {
  const cartDetails = store.get(StoreKeys.cart);
  const item = cartDetails.cartItems.find((x) => x.sku === sku);
  store.set('skuBeingRemoved', sku);
  try {
    await removeItemFromCart(cartDetails.cartId, item.cartItemId);
    store.set('retrieveTriggeredFromRemove', true);
    const cart = await retrieveCart();
    store.set('skuBeingRemoved', '');
    storeCartResponse(cart);
    setTimeout(async () => {
      //Forces the product cards to resync heights
      await (document.getElementsByTagName('app-product-cards')[0] as any)?.equaliseHeights();
    }, 20);
  } catch (ex) {
    store.set(StoreKeys.responseError, new ResponseError('error removing item from cart'));
  }
};

export const clearCart = async (): Promise<void> => {
  // remove all cart items when clicking on the minus button to remove the last mobile plan item (which is also the last item in cart)
  const cartDetails = store.get(StoreKeys.cart);
  try {
    // remove all (mobile) items in parallel, and set loading state on button for all mobile plan cards
    if (cartDetails?.cartItems?.length > 0) {
      store.set('skuBeingRemoved', 'clearCart');
      await Promise.all(
        cartDetails?.cartItems?.map((item) => {
          return removeItemFromCart(cartDetails.cartId, item.cartItemId);
        })
      );
      abandonCart();
      store.set('skuBeingRemoved', '');
    }
  } catch (ex) {
    store.set('skuBeingRemoved', '');
    store.set(StoreKeys.responseError, new ResponseError('error clearing cart'));
  }
};

export const storeCartResponse = (cart: CartResponse): void => {
  // Compare request address and cart address
  const requestAddress = store.get('address');
  const cartAddress = getAddressFromCart(cart);
  const isAddressSame = isSameAddress(
    mapper.mapProductSearchRequestModel(requestAddress),
    mapper.mapProductSearchRequestModel(cartAddress)
  );

  // Abandon cart if addresses are different
  if (requestAddress && cartAddress && !isAddressSame) {
    abandonCart();
    dispatchResetCartEvent();
  } else {
    store.set(StoreKeys.cart, cart);
    window.sessionStorage.setItem(SessionStorageKeys.cart, JSON.stringify(cart));
  }
};
